module.exports = __webpack_public_path__ + "img/cs-stack.d455ef3f.jpg";